<template>
  <v-dialog content-class="img-dialog" :value="open" scrollable eager persistent :overlay-color="color">
    <v-btn fixed icon top right @click.prevent="_close()">
      <v-icon :color="color == 'colorWhite' ? 'black' : 'white'">{{ icon.mdiClose }}</v-icon>
    </v-btn>
    <div
      style="width: 90%; max-height: 90vh; margin-right: auto; margin-left: auto;"
      class="d-flex align-center justify-center flex-wrap"
    >
      <video
        v-if="isVideo"
        id="global_video_player"
        :src="singleMedia"
        width="100%"
        height="100%"
        controls
      ></video>

      <template v-if="!isVideo && multiMedia.length">
        <v-img v-for="imgUrl in multiMedia" :src="imgUrl" contain style="max-height: 100%; width: 50%; max-width: 50%"></v-img>
      </template>
      <v-img v-if="!isVideo && singleMedia" :src="singleMedia" contain style="max-height: 100%; max-width: 100%;"></v-img>
    </div>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MediaPopup',
  computed: {
    ...mapState({
      media: state => state.MediaPopupHelper.media,
      isVideo: state => state.MediaPopupHelper.isVideo,
      color: state => state.MediaPopupHelper.color,
      open: state => state.MediaPopupHelper.open,
    }),
    multiMedia() {
      if (!this.isVideo && this.media && Array.isArray(this.media) && this.media.length > 1) {
        return this.media;
      }

      return [];
    },
    singleMedia() {
      if (this.media) {
        if (typeof this.media === 'string') {
          return this.media;
        } else if (Array.isArray(this.media) && (this.media.length === 1 || this.isVideo)) {
          return this.media[0];
        }
      }

      return '';
    }
  },
  data: () => ({
    icon: {
      mdiClose,
    },
  }),
  methods: {
    ...mapActions(['closeMediaPopup']),
    _close() {
      if (document.getElementById('global_video_player')) {
        document.getElementById('global_video_player').pause()
        document.getElementById('global_video_player').currentTime = 0
      }

      this.closeMediaPopup()
    },
  },
}
</script>
